import api from './api';
import { handleApiError } from './financialService';

class DashboardFinanceiroService {
  constructor() {
    this.endpoint = '/financeiro/dashboard/';
  }

  async getOverview(mes = null, ano = null) {
    try {
      const params = {};
      if (mes) params.mes = mes;
      if (ano) params.ano = ano;
      
      const response = await api.get(`${this.endpoint}overview`, { params });
      return response.data;
    } catch (error) {
      throw handleApiError(error, 'Erro ao buscar overview do dashboard');
    }
  }

  async getFluxoCaixa(tipo = 'mensal', ano = null) {
    try {
      const params = { tipo };
      if (ano) params.ano = ano;
      
      const response = await api.get(`${this.endpoint}fluxo-caixa`, { params });
      return response.data;
    } catch (error) {
      throw handleApiError(error, 'Erro ao buscar fluxo de caixa');
    }
  }

  async getReceitasPorCategoria(mes = null, ano = null) {
    try {
      const params = {};
      if (mes) params.mes = mes;
      if (ano) params.ano = ano;
      
      const response = await api.get(`${this.endpoint}receitas-por-categoria`, { params });
      return response.data;
    } catch (error) {
      throw handleApiError(error, 'Erro ao buscar receitas por categoria');
    }
  }

  async getDespesasPorCategoria(mes = null, ano = null) {
    try {
      const params = {};
      if (mes) params.mes = mes;
      if (ano) params.ano = ano;
      
      const response = await api.get(`${this.endpoint}despesas-por-categoria`, { params });
      return response.data;
    } catch (error) {
      throw handleApiError(error, 'Erro ao buscar despesas por categoria');
    }
  }

  async getDespesasPorTipo(mes = null, ano = null) {
    try {
      const params = {};
      if (mes) params.mes = mes;
      if (ano) params.ano = ano;
      
      const response = await api.get(`${this.endpoint}despesas-por-tipo`, { params });
      return response.data;
    } catch (error) {
      throw handleApiError(error, 'Erro ao buscar despesas por tipo');
    }
  }

  async getTopClientes(mes = null, ano = null, limit = 10) {
    try {
      const params = { limit };
      if (mes) params.mes = mes;
      if (ano) params.ano = ano;
      
      const response = await api.get(`${this.endpoint}top-clientes`, { params });
      return response.data;
    } catch (error) {
      throw handleApiError(error, 'Erro ao buscar top clientes');
    }
  }

  async getAtividadesRecentes(limit = 20) {
    try {
      const response = await api.get(`${this.endpoint}atividades-recentes`, {
        params: { limit }
      });
      return response.data;
    } catch (error) {
      throw handleApiError(error, 'Erro ao buscar atividades recentes');
    }
  }

  async getAlertas() {
    try {
      const response = await api.get(`${this.endpoint}alertas`);
      return response.data;
    } catch (error) {
      throw handleApiError(error, 'Erro ao buscar alertas');
    }
  }

  async getProjecao(meses = 3) {
    try {
      const response = await api.get(`${this.endpoint}projecao`, {
        params: { meses }
      });
      return response.data;
    } catch (error) {
      throw handleApiError(error, 'Erro ao buscar projeção');
    }
  }
}

export default new DashboardFinanceiroService();
